import { gql } from '@apollo/client'

import { DROP_OFF_ADDRESS_FRAGMENT } from './address'

export const DROP_OFF_LOCATION_FRAGMENT = gql`
  fragment DropOffLocation on DropOffLocation {
    name
    address {
      ...DropOffAddress
    }
  }
  ${DROP_OFF_ADDRESS_FRAGMENT}
`
